document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('[data-scroll-to-pincode]');
  const target = document.getElementById('clickpost-edd-section');

  if (!trigger) return;

  if (!target) {
    trigger.classList.add('hidden');
    return;
  }

  trigger.addEventListener('click', (event) => {
    event.preventDefault();

    const header = document.getElementById('main-header');
    const headerOffset = header?.getBoundingClientRect().bottom ?? 0;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;

    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  });
});
